import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  MultiSelect,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import {
  IconBarcode,
  IconBrandBootstrap,
  IconBuildingSkyscraper,
  IconSearch,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import {
  useDebouncedState,
  useDebouncedValue,
  useDisclosure,
  useHotkeys,
} from "@mantine/hooks";
import { _localization } from "../../../config/location";
import { useDeferredValue, useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import React from "react";
import { useLocation } from "react-router-dom";
import { changeSearchValue } from "../../../_base/helper/FunctionHelper";
import { getMasterOrgSelect } from "../../../service/getSelectApi";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const WeighingReport = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [search, setSearch] = useState<any>({
    itemIds: _searchJson && checkedPinSearch ? _searchJson.itemIds : [],
    idCns: _searchJson && checkedPinSearch ? _searchJson.idCns : [],
    maChungs: _searchJson && checkedPinSearch ? _searchJson.maChungs : [],
    maNhoms: _searchJson && checkedPinSearch ? _searchJson.maNhoms : [],
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300
  );

  const [searchItem, setSearchItem] = useState<string>("");
  const [debouncedSearchItem] = useDebouncedValue<string>(searchItem, 300);
  const [dataItem, setDataItem] = useState<ComboboxItem[]>([]);
  const [searchCatSegment4d, setSearchCatSegment4d] = useState<string>("");
  const [debouncedSearchCatSegment4d] = useDebouncedValue<string>(
    searchCatSegment4d,
    300
  );
  const [dataCatSegment4d, setDataCatSegment4d] = useState<ComboboxItem[]>([]);
  const [searchCatSegment5e, setSearchCatSegment5e] = useState<string>("");
  const [debouncedSearchCatSegment5e] = useDebouncedValue<string>(
    searchCatSegment5e,
    300
  );
  const [dataCatSegment5e, setDataCatSegment5e] = useState<any[]>([]);
  const [dataMasterOrg, setDataMasterOrg] = useState<ComboboxItem[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "maSp",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue }) => (
          <Badge variant="dot" color="green">
            {renderedCellValue}
          </Badge>
        ),
      },
      { accessorKey: "tenSp", header: "Tên sản phẩm" },
      { accessorKey: "dvt", header: "Đơn vị tính" },
      {
        accessorKey: "name",
        header: "Chi nhánh",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {row.original.maCn} - {row.original.name}
          </Text>
        ),
      },
      { accessorKey: "slTon", header: "Số lượng tồn" },
      { accessorKey: "slChoNhap", header: "Số lượng chờ nhập" },
      { accessorKey: "slChoXuat", header: "Số lượng chờ xuất" },
      { accessorKey: "slDatHang", header: "Số lượng đặt hàng" },
      {
        accessorKey: "maChung",
        header: "Chủng",
        Cell: ({ row }) =>
          row.original.maChung ? (
            <Text fw={500} size="12.5px">
              {row.original.maChung} - {row.original.tenChung}
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "maNhom",
        header: "Nhóm",
        Cell: ({ row }) =>
          row.original.maNhom ? (
            <Text fw={500} size="12.5px">
              {row.original.maNhom} - {row.original.tenNhom}
            </Text>
          ) : (
            <></>
          ),
      },
    ],
    []
  );

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/TblInventorySerialOnhand/get-item-onhand-balance-by-branch`;

      const bodySearch = {
        keySearch: keySearch,
        skip: pagination.pageIndex,
        take: pagination.pageSize,
        isAll: false,
        itemIds: search?.itemIds,
        idCns: search?.idCns,
        maChungs: search?.maChungs,
        maNhoms: search?.maNhoms,
      };

      const filteredBodySearch = Object.fromEntries(
        Object.entries(bodySearch).filter(([key, value]) => {
          if (Array.isArray(value)) {
            return value.length > 0;
          }
          return value !== "";
        })
      );

      const res = await repositoryDelivery.post<MessageResponse<any>>(
        url,
        filteredBodySearch
      );

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        })
      );
    }
  };

  // const exportDataExcel = async () => {
  //   open();
  //   try {
  //     let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

  //     const params = new URLSearchParams();
  //     Object.entries(search).forEach(([key, value]) => {
  //       if (Array.isArray(value) && value.length > 0) {
  //         value.forEach((item) => params.append(key, String(item)));
  //       } else if (typeof value === "string" && value.length > 0) {
  //         params.append(key, value);
  //       }
  //     });

  //     if (keySearch.length > 0) {
  //       url += `&KeySearch=${keySearch?.trim()}`;
  //     }

  //     url += `&${params.toString()}`;

  //     const baseUrl = `/api/v1/ItemComparison/export-excel${url}`;

  //     const _url = BASE_API_MDM + baseUrl;
  //     const token = localStorage.getItem("token");

  //     const response = await fetch(_url, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/vnd.ms-excel",
  //         Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
  //       },
  //     });

  //     if (!response.ok) {
  //       NotificationExtension.Fails("Export Excel thất bại !");
  //     } else {
  //       const blob = await response.blob();
  //       const urlss = window.URL.createObjectURL(blob);
  //       const _name = new Date().toISOString().slice(0, 10);
  //       let filename = "danh_sach_voucher.xlsx";
  //       const link = document.createElement("a");
  //       link.href = urlss;
  //       link.download = filename;
  //       document.body.appendChild(link);
  //       link.click();
  //       link.remove();
  //       window.URL.revokeObjectURL(url);
  //       NotificationExtension.Success("Export Excel thành công !");
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     close();
  //   }
  // };

  const fetchDataItem = async () => {
    let url = "api/v1/TblItem/get-list?Skip=0&Take=50";

    if (searchItem?.length > 0) {
      url += `&ListItemCode=${searchItem?.toUpperCase()}`;
    }

    const response = await repositoryPos.get<MessageResponse<any>>(url);

    if (response && response.success) {
      const transformedData = response.data
        ?.filter((item: any) => item.itemCode && item.itemName)
        .map((item: any) => ({
          label: item.itemCode + " - " + item.itemName,
          value: item.itemId?.toString(),
        }));
      const uniqueData = Array.from(
        new Set(transformedData.map((item: any) => item.value))
      ).map((value) =>
        transformedData.find((item: any) => item.value === value)
      );
      setDataItem(uniqueData);
    }
  };

  const fetchCatSegment4d = async () => {
    let url = "/api/v1/TblCatSegment4d/get-list?Skip=0&Take=50";

    if (searchCatSegment4d?.length > 0) {
      url += `&KeySearch=${searchCatSegment4d}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const dataAPI = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment4d(dataAPI);
    }
  };

  const fetchCatSegment5e = async () => {
    let url = "/api/v1/TblCatSegment5e/get-list?Skip=0&Take=50";

    if (search.maChungs && search?.maChungs?.length > 0) {
      url += `&ListCodeString4=${search.maChungs.join(",")}`;
    }

    if (searchCatSegment5e?.length > 0) {
      url += `&KeySearch=${searchCatSegment5e}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const dataAPI = res?.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
          segment4CodeString: item.segment4CodeString,
        }));
      setDataCatSegment5e(dataAPI);

      if (
        search.maChungs &&
        search.maChungs?.length > 0 &&
        debouncedSearchCatSegment5e.length === 0
      ) {
        const dataMaNhoms = dataAPI
          .filter((i: any) => search.maNhoms?.includes(i.value))
          .map((i: any) => i.value);

        setSearch((prev: any) => ({
          ...prev,
          maNhoms: dataMaNhoms,
        }));
      }
    }
  };

  const fetchDataMasterOrg = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.value)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: String(item.value),
        }));
      setDataMasterOrg(data);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    fetchDataMasterOrg();
  }, []);

  useEffect(() => {
    fetchDataItem();
  }, [debouncedSearchItem]);

  useEffect(() => {
    fetchCatSegment4d();
  }, [debouncedSearchCatSegment4d]);

  useEffect(() => {
    fetchCatSegment5e();
  }, [debouncedSearchCatSegment5e, search.maChungs]);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningWeighingReport"
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["mrt-row-select", "mrt-row-numbers"],
          right: ["enforcement", "action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage()
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningWeighingReport",
      JSON.stringify(columnPinning)
    );
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-numbers", "maVt"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Flex gap={"md"}>
            {/* <Button
                leftSection={<IconFileTypeCsv size={16} />}
                onClick={() => exportDataExcel()}
              >
                Export Excel
              </Button> */}
          </Flex>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa tìm kiếm"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Mã sản phẩm"
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              data={dataItem}
              value={
                search.itemIds && search.itemIds?.length > 0
                  ? search.itemIds
                  : []
              }
              searchable
              clearable
              onSearchChange={setSearchItem}
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
              onChange={(e) =>
                changeSearchValue(e ? e : [], "itemIds", setSearch)
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Chủng"
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              data={dataCatSegment4d}
              value={
                search.maChungs && search.maChungs?.length > 0
                  ? search.maChungs
                  : []
              }
              searchable
              clearable
              onSearchChange={setSearchCatSegment4d}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => {
                changeSearchValue(e ? e : [], "maChungs", setSearch);
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Nhóm"
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              data={dataCatSegment5e?.map((i: any) => ({
                label: i.label,
                value: i.value,
              }))}
              value={
                search.maNhoms && search.maNhoms?.length > 0
                  ? search.maNhoms
                  : []
              }
              searchable
              clearable
              onSearchChange={setSearchCatSegment5e}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => {
                changeSearchValue(e ? e : [], "maNhoms", setSearch);
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Chi nhánh"
              leftSection={<IconBuildingSkyscraper color="#15aabf" />}
              data={dataMasterOrg}
              value={
                search?.idCns && search?.idCns.length > 0 ? search?.idCns : []
              }
              searchable
              clearable
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
              onChange={(e) =>
                changeSearchValue(e ? e : [], "idCns", setSearch)
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default WeighingReport;
